module.exports = __webpack_public_path__ + "static/media/img_hand_shaking.32350d62.png";